import React from 'react';
import { Text } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';

/**
 * EmploymentStatusのProps
 */
interface EmploymentStatusProps {
  /** 雇用形態 */
  formDivision: string | undefined;
  /** 雇用期間 */
  period: string | undefined;
}

/**
 * 雇用形態と雇用期間を表示するコンポーネント
 *
 * @param {string} props.formDivision - 雇用形態の区分
 * @param {string} props.period - 雇用期間
 */
export const EmploymentStatus: React.FC<EmploymentStatusProps> = ({
  formDivision,
  period,
}) => {
  return (
    <SectionItem label="雇用形態">
      {formDivision && (
        <Text weight="bold" style={{ marginBottom: '16px' }}>
          {formDivision}
        </Text>
      )}
      {period && <TextWithLF text={period} />}
    </SectionItem>
  );
};
